import angular from "angular"
import angularBootstrap from "angular-ui-bootstrap";

let mod = angular
    .module('bookingModule.routeCard', [
        angularBootstrap
    ])
    .component('routeCard', {
        template: require('./route-card.html'),
        controller: ['$uibModal', controller],
        bindings: {
            routes: '<',
            route: '<',
            passengersCount: '<',
            routeInd: '<',
            isEditing: '<',
            editingRouteInd: '<',
            returnSeatsAllocations: '&',
            returnSeatsComp: '&',
            returnWithBedding: '&'
        }
    });

function controller($uibModal) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.typeLetters = $ctrl.route.label.split('');

        $ctrl.showAllocations =
            ($ctrl.route.topSeatsCount > 0 || $ctrl.route.bottomSeatsCount > 0) &&
            $ctrl.route.car.hasSeatNumbers;

        if ($ctrl.showAllocations) {
            $ctrl.selectedAllocation = null;
            $ctrl.seatsAllocations = getSeatsAllocations();
            if ($ctrl.route.allocationTop || $ctrl.route.allocationBottom) {
                for (let i = 0; i < $ctrl.seatsAllocations.length; i++) {
                    if ($ctrl.seatsAllocations[i].top == $ctrl.route.allocationTop &&
                        $ctrl.seatsAllocations[i].bottom == $ctrl.route.allocationBottom) {
                        $ctrl.selectedAllocation = $ctrl.seatsAllocations[i];
                        break;
                    }
                }
            }
            if (!$ctrl.selectedAllocation) {
                $ctrl.selectedAllocation = $ctrl.seatsAllocations[0];
            }
        }

        $ctrl.showSeatsComp =
            $ctrl.passengersCount > 1 &&
            ($ctrl.route.carGroup.typeSlug == 'placcart' || $ctrl.route.carGroup.typeSlug == 'obwiy');

        if ($ctrl.showSeatsComp) {
            $ctrl.seatsComp = null;
            if ($ctrl.route.seatsComp) {
                $ctrl.seatsComp = $ctrl.route.seatsComp;
            }
        }

        $ctrl.showWithBedding = $ctrl.route.carGroup.typeSlug == 'placcart' && $ctrl.route.train.timeInWay.hours < 6;

        if ($ctrl.showWithBedding) {
            $ctrl.withBedding = $ctrl.route.withBedding;
        }
    };

    function getSeatsAllocations() {

        let seatsAllocations = [
            {
                top: null,
                bottom: null,
                text: 'не важно',
            }
        ];

        for (let i = 0; i <= $ctrl.passengersCount; i++) {
            let topP = i;
            let botP = $ctrl.passengersCount - i;
            if (topP <= $ctrl.route.topSeatsCount && botP <= $ctrl.route.bottomSeatsCount) {
                seatsAllocations.push({
                    top: topP,
                    bottom: botP,
                    text: getText(topP, botP)
                });
            }
        }

        function getText(topSeats, bottomSeats) {

            if (topSeats && !bottomSeats) {
                if (topSeats == 1) {
                    return '1 верхнее';
                } else {
                    return topSeats + ' верхних';
                }
            }

            if (!topSeats && bottomSeats) {
                if (bottomSeats == 1) {
                    return '1 нижнее';
                } else {
                    return bottomSeats + ' нижних';
                }
            }

            return bottomSeats + ' ниж. и ' + topSeats + ' верх.';
        }

        for (let i = 0; i < seatsAllocations.length; i++) {
            seatsAllocations[i].text = 'Расп. мест: ' + seatsAllocations[i].text;
        }

        return seatsAllocations;
    }

    $ctrl.allocationChanged = function () {
        $ctrl.returnSeatsAllocations({
            top: $ctrl.selectedAllocation.top,
            bottom: $ctrl.selectedAllocation.bottom
        });
    };

    $ctrl.seatsCompChanged = function () {
        $ctrl.returnSeatsComp({seatsComp: $ctrl.seatsComp});
    };

    $ctrl.changeWithBedding = function () {
        $ctrl.returnWithBedding({withBedding: $ctrl.withBedding});
    };

    $ctrl.openTrainFullRoute = function () {
        $uibModal.open({
            component: 'trainRoute',
            size: 'lg',
            resolve: {
                route: function () {
                    return $ctrl.route;
                },
                train: function () {
                    return $ctrl.route.train
                }
            },
            windowTemplateUrl: 'train-route-popup.html'
        });
    };

    $ctrl.removeRoute = function () {
        if (confirm('Вы действительно хотите удалить маршрут?')) {
            $ctrl.routes.splice($ctrl.routeInd, 1);
        }
    };
}

export default mod.name;



// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/route-card/route-card.js